import React from 'react';
import PropTypes from 'prop-types';

const SVG = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" className={props.className} viewBox="0 0 24 24" fill="none">
    <path d="M12 9.75L6 15H11.25V23.25H12.75V15H18L12 9.75Z" fill="black" />
    <path d="M0 1.5V19.5C0 20.328 0.672 21 1.5 21H7.5V19.5H1.5V7.5H22.5V19.5H16.5V21H22.5C23.328 21 24 20.328 24 19.5V1.5C24 0.672 23.328 0 22.5 0H1.5C0.672 0 0 0.672 0 1.5ZM1.5 6V1.5H22.5V6H1.5Z" fill="black" />
  </svg>
);

SVG.propTypes = {
  className: PropTypes.string,
};

export default SVG;
